import { PPKontentCollections } from './constants';
import {
  AIG_WOMENS_OPEN_CHAMPIONSHIP,
  THE_OPEN_CHAMPIONSHIP,
} from './constants/pp-classnames-utils';
import { ChampionshipContact } from './constants';

export const CHAMPIONSHIPS = [
  THE_OPEN_CHAMPIONSHIP,
  AIG_WOMENS_OPEN_CHAMPIONSHIP,
];

const CHAMPIONSHIP_ENV_DICT = [
  {
    kontentCollection: PPKontentCollections.PlayerPortalTheOpen,
    envValue: THE_OPEN_CHAMPIONSHIP,
    qualifyingKontentCollection: PPKontentCollections.Qualifying,
  },
  {
    kontentCollection: PPKontentCollections.PlayerPortalAIGWO,
    envValue: AIG_WOMENS_OPEN_CHAMPIONSHIP,
    qualifyingKontentCollection: PPKontentCollections.AIGWOQualifying,
  },
];

const CHAMPIONSHIP_URL_DICT = [
  {
    envValue: THE_OPEN_CHAMPIONSHIP,
    defaultDomain: process.env['NEXT_PUBLIC_CLIENT_APP_TO_DOMAIN'],
  },
  {
    envValue: AIG_WOMENS_OPEN_CHAMPIONSHIP,
    defaultDomain: process.env['NEXT_PUBLIC_CLIENT_APP_AIGWO_DOMAIN'],
  },
];

export const getChampEnvValueBasedOnCollection = (
  champCollection: string | undefined,
): string => {
  const envValue =
    CHAMPIONSHIP_ENV_DICT.find(c => c.kontentCollection === champCollection)
      ?.envValue || '';
  return envValue;
};

export const getRedirectToChampionship = (
  champCollection: string | undefined,
): string | undefined => {
  const currentEnvValue = getChampFromEnv();
  const newEnvValue = getChampEnvValueBasedOnCollection(champCollection);

  if (currentEnvValue === newEnvValue) {
    return undefined;
  }

  const champUrlObj = CHAMPIONSHIP_URL_DICT.find(
    c => c.envValue === newEnvValue,
  );

  return champUrlObj?.defaultDomain;
};

export const getChampFromEnv = (): string | undefined => {
  const envVal = process.env['NEXT_PUBLIC_CHAMPIONSHIP_NAME'];

  return envVal;
};

export const getChampKontentCollectionBasedOnEnv = (): string | undefined => {
  const champFromEnv = getChampFromEnv();

  const champCollection = CHAMPIONSHIP_ENV_DICT.find(
    c => c.envValue === champFromEnv,
  )?.kontentCollection;

  return champCollection;
};

export const getQualifyingKontentCollectionBasedOnEnv = ():
  | PPKontentCollections
  | undefined => {
  const champFromEnv = process.env['NEXT_PUBLIC_CHAMPIONSHIP_NAME'];

  const qualifyingCollection = CHAMPIONSHIP_ENV_DICT.find(
    c => c.envValue === champFromEnv,
  )?.qualifyingKontentCollection;

  return qualifyingCollection;
};

export const parsePPContactIdentifier = (
  ppContactIdentifier: string | undefined,
) => {
  const ppContactsJson = ppContactIdentifier;

  if (!ppContactsJson) return undefined;

  let parsedPPContacts: ChampionshipContact[];
  try {
    parsedPPContacts = JSON.parse(ppContactsJson) as ChampionshipContact[];
  } catch (e) {
    console.error('Invalid format for PPContactIdentifier attribute', e);
    return undefined;
  }

  return parsedPPContacts;
};
